/*!
 * devextreme-angular
 * Version: 26.1.6
 * Build date: Fri Oct 16 2026
 *
 * Copyright (c) 2012 - 2026 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/DevExtreme
 */

/* tslint:disable:max-line-length */


import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import {
    DxIntegrationModule,
    NestedOptionHost,
} from 'devextreme-angular/core';
import { NestedOption } from 'devextreme-angular/core';


@Component({
    selector: 'dxo-chat-speech-recognition-config',
    template: '',
    styles: [''],
    imports: [ DxIntegrationModule ],
    providers: [NestedOptionHost]
})
export class DxoChatSpeechRecognitionConfigComponent extends NestedOption implements OnDestroy, OnInit  {
    @Input()
    get continuous(): boolean {
        return this._getOption('continuous');
    }
    set continuous(value: boolean) {
        this._setOption('continuous', value);
    }

    @Input()
    get grammars(): Array<string> {
        return this._getOption('grammars');
    }
    set grammars(value: Array<string>) {
        this._setOption('grammars', value);
    }

    @Input()
    get interimResults(): boolean {
        return this._getOption('interimResults');
    }
    set interimResults(value: boolean) {
        this._setOption('interimResults', value);
    }

    @Input()
    get lang(): string {
        return this._getOption('lang');
    }
    set lang(value: string) {
        this._setOption('lang', value);
    }

    @Input()
    get maxAlternatives(): number {
        return this._getOption('maxAlternatives');
    }
    set maxAlternatives(value: number) {
        this._setOption('maxAlternatives', value);
    }


    protected get _optionPath() {
        return 'speechRecognitionConfig';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  imports: [
    DxoChatSpeechRecognitionConfigComponent
  ],
  exports: [
    DxoChatSpeechRecognitionConfigComponent
  ],
})
export class DxoChatSpeechRecognitionConfigModule { }
